import { FC, PropsWithChildren, useContext } from 'react';

import { Box } from '@ui';

import { LiveAnalysisTableContext } from './context';
import * as styles from './styles.css';

export type WithIndex<T = unknown> = { index: number } & T;
export const LiveAnalysisTableCell: FC<PropsWithChildren<WithIndex>> = ({ children, index }) => {
    const { parameters } = useContext(LiveAnalysisTableContext);
    const columns = parameters.length;
    const isLast = index === columns - 1;
    return (
        <Box key={index} className={styles.cellOuter}>
            <Box className={styles.cellInner[isLast ? 'last' : 'default']}>{children}</Box>
        </Box>
    );
};
